export default "__VITE_ASSET__DuNMwb9J__"